/*
  ULTRAWRLD — small global script: header height variable, text-menu panel, image reveal.
  No dependencies. Keeps the theme's cart drawer / cart count logic untouched.
  Motion here is limited to the approved set: menu panel 240ms, image reveal 400ms opacity.
*/
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  // Marks JS as available so the image-reveal styles only apply when this script can complete them.
  root.classList.add('u-js');

  function setHeaderHeightVar() {
    var header = doc.querySelector('[data-u-header]');
    if (!header) return;
    var h = header.offsetHeight;
    // Measured height goes to its own variable so the CSS height never feeds back on itself.
    root.style.setProperty('--u-header-actual', h + 'px');
    // Compatibility with theme scripts/sections that read the legacy variable.
    root.style.setProperty('--m-header-height', h + 'px');
  }

  function initHeader() {
    var header = doc.querySelector('[data-u-header]');
    if (!header) return;
    setHeaderHeightVar();
    window.addEventListener('resize', setHeaderHeightVar);
  }

  function initMenu() {
    var toggle = doc.querySelector('[data-u-menu-toggle]');
    var menu = doc.querySelector('[data-u-menu]');
    if (!toggle || !menu) return;

    var openLabel = toggle.getAttribute('data-label-open') || 'Menu';
    var closeLabel = toggle.getAttribute('data-label-close') || 'Close';
    var labelEl = toggle.querySelector('[data-u-menu-label]');
    var isOpen = false;

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var nodes = menu.querySelectorAll(FOCUSABLE);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && doc.activeElement === first) {
        e.preventDefault();
        toggle.focus();
      } else if (!e.shiftKey && doc.activeElement === last) {
        e.preventDefault();
        toggle.focus();
      }
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
      trapFocus(e);
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      menu.hidden = false;
      requestAnimationFrame(function () {
        menu.classList.add('is-open');
        root.classList.add('u-menu-open');
      });
      toggle.setAttribute('aria-expanded', 'true');
      if (labelEl) labelEl.textContent = closeLabel;
      doc.addEventListener('keydown', onKey);
      var firstLink = menu.querySelector(FOCUSABLE);
      if (firstLink) setTimeout(function () { firstLink.focus(); }, 60);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      menu.classList.remove('is-open');
      root.classList.remove('u-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      if (labelEl) labelEl.textContent = openLabel;
      doc.removeEventListener('keydown', onKey);
      var done = function () {
        if (!isOpen) menu.hidden = true;
        menu.removeEventListener('transitionend', done);
      };
      menu.addEventListener('transitionend', done);
      setTimeout(done, 300);
      toggle.focus();
    }

    toggle.addEventListener('click', function () {
      isOpen ? close() : open();
    });

    menu.addEventListener('click', function (e) {
      if (e.target.closest('[data-u-menu-close]')) close();
    });

    // Close when leaving the mobile breakpoint.
    var mq = window.matchMedia('(min-width: 1024px)');
    var onMq = function (ev) { if (ev.matches) close(); };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);
  }

  // Image reveal: opacity 0 → 1 over 400ms once each marked image has loaded. No translation.
  function markLoaded(img) { img.classList.add('is-loaded'); }
  function initReveal(scope) {
    var imgs = (scope || doc).querySelectorAll('img[data-u-reveal]:not(.is-loaded)');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete && img.naturalWidth > 0) { markLoaded(img); continue; }
      img.addEventListener('load', function (e) { markLoaded(e.target); }, { once: true });
      img.addEventListener('error', function (e) { markLoaded(e.target); }, { once: true });
    }
  }

  function init() {
    initHeader();
    initMenu();
    initReveal();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();

  // Late-added images (section rendering, lazy blocks)
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      for (var r = 0; r < records.length; r++) {
        var added = records[r].addedNodes;
        for (var n = 0; n < added.length; n++) {
          if (added[n].nodeType === 1) initReveal(added[n].parentNode || doc);
        }
      }
    }).observe(doc.documentElement, { childList: true, subtree: true });
  }

  // Theme editor: re-init when a section is reloaded.
  doc.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-u-header]')) init();
    else initReveal(e.target);
  });
})();
